import React from 'react';
import './header.css';

import { useDispatch } from 'react-redux';

function Header() {
    const dispatch = useDispatch();
    //const navegador = useNavigate();
    //const nomeUsuario = useSelector(state => state.usuario.name);

    function Logout() {
        dispatch({
            type: "SET_USUARIO",
            payload: {
                name: "",
                id: "0",
                categoria: "",
                fone: '0'
            }
        });
    }

    function limpaDadosMemoria() {
        localStorage.setItem("produtor", "");
        localStorage.setItem("cliente", "");
    }

    return (
        <header id="main-header" >
            <div className="header-content" >
                <div style={{ flexDirection: 'row' }} >
                    <label style={{
                        color: '#fff',
                        marginTop: 5, fontSize: 14
                    }} ></label>
                </div>

                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center',
                    marginLeft: 17
                }} >
                    <a onClick={() => limpaDadosMemoria()} href={"/" + 'sta'} ><img
                        style={{ cursor: 'pointer', height: 30, width: 30, marginTop: 7, marginRight: 5 }}
                        src={'https://cdn-icons-png.flaticon.com/512/6807/6807166.png'} /></a>

                    <label style={{
                        fontWeight: 'bold',
                        color: '#fff',
                        marginTop: 6,
                        fontSize: 20,
                    }}  >Perímetro Vs. 2.0</label>
                </div>
            </div>
        </header>
    );
}

export default Header;